/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnedisStatus } from '../models/EnedisStatus';
import type { PaginatedEnedisStatusList } from '../models/PaginatedEnedisStatusList';
import type { PatchedEnedisStatus } from '../models/PatchedEnedisStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class ClientsEnedisStatusService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns PaginatedEnedisStatusList
     * @throws ApiError
     */
    public clientsEnedisStatusList({
        page,
        pageSize,
    }: {
        /**
         * A page number within the paginated result set.
         */
        page?: number,
        /**
         * Number of results to return per page.
         */
        pageSize?: number,
    }): CancelablePromise<PaginatedEnedisStatusList> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-enedis-status/',
            query: {
                'page': page,
                'page_size': pageSize,
            },
        });
    }

    /**
     * @returns EnedisStatus
     * @throws ApiError
     */
    public clientsEnedisStatusCreate({
        requestBody,
    }: {
        requestBody: EnedisStatus,
    }): CancelablePromise<EnedisStatus> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clients-enedis-status/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EnedisStatus
     * @throws ApiError
     */
    public clientsEnedisStatusRetrieve({
        id,
    }: {
        /**
         * A unique integer value identifying this enedis status.
         */
        id: number,
    }): CancelablePromise<EnedisStatus> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clients-enedis-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns EnedisStatus
     * @throws ApiError
     */
    public clientsEnedisStatusUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this enedis status.
         */
        id: number,
        requestBody: EnedisStatus,
    }): CancelablePromise<EnedisStatus> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/clients-enedis-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns EnedisStatus
     * @throws ApiError
     */
    public clientsEnedisStatusPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this enedis status.
         */
        id: number,
        requestBody?: PatchedEnedisStatus,
    }): CancelablePromise<EnedisStatus> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/clients-enedis-status/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns void
     * @throws ApiError
     */
    public clientsEnedisStatusDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this enedis status.
         */
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clients-enedis-status/{id}/',
            path: {
                'id': id,
            },
        });
    }

}
